import * as XLSX from "xlsx";
import { ClockifyTimeEntry } from "./ClockifyTimeEntry";
import TimeFormatter from "../extensions/TimeFormatter";
import { calculateBudgetaryPerformance } from "./clockifyTimeEntriesSlice";

export class ClockifyTimeEntriesExcelExporter {
  exportToExcel(timeEntries: ClockifyTimeEntry[], fileName: string) {
    const fileNameWithExtension = fileName.endsWith(".xlsx")
      ? fileName
      : `${fileName}.xlsx`;

    const timeFormatter = new TimeFormatter();

    const headers = [
      "Task Number",
      "Description",
      "Developer",
      "Time Spent",
      "Total Time on Task",
      "Time Budget",
      "Budgetary Performance",
      "Date Range",
      "Date Start",
      "Date End",
      "Decimal Time Spent",
      "Decimal Total Time on Task",
      "Decimal Time Budget",
    ];

    const data = [...timeEntries]
      .sort(
        (a, b) => new Date(b.dateEnd).getTime() - new Date(a.dateEnd).getTime()
      )
      .map((entry) => ({
        "Task Number": entry.gitLabTaskId || "N/A",
        Description: entry.description,
        Developer: entry.developerName || "N/A",
        "Time Spent": timeFormatter.toHoursAndMinutes(entry.timeSpentInHours),
        "Total Time on Task":
          entry.totalSpentTimeOnTaskInHours === 0
            ? "N/A"
            : timeFormatter.toHoursAndMinutes(
                entry.totalSpentTimeOnTaskInHours
              ),
        "Time Budget":
          entry.taskTimeBudget > 0
            ? timeFormatter.toHoursAndMinutes(entry.taskTimeBudget)
            : "N/A",
        "Budgetary Performance": Number(
          calculateBudgetaryPerformance(entry).toFixed(2)
        ),
        "Date Range": `${new Date(
          entry.dateStart
        ).toLocaleDateString()} - ${new Date(
          entry.dateEnd
        ).toLocaleDateString()}`,
        "Date Start": new Date(entry.dateStart).toLocaleDateString(),
        "Date End": new Date(entry.dateEnd).toLocaleDateString(),
        "Decimal Time Spent":
          typeof entry.timeSpentInHours === "number"
            ? Number(entry.timeSpentInHours.toFixed(2))
            : 0,
        "Decimal Total Time on Task":
          typeof entry.totalSpentTimeOnTaskInHours === "number"
            ? Number(entry.totalSpentTimeOnTaskInHours.toFixed(2))
            : 0,
        "Decimal Time Budget":
          typeof entry.taskTimeBudget === "number"
            ? entry.taskTimeBudget > 0
              ? Number(entry.taskTimeBudget.toFixed(2))
              : "N/A"
            : "N/A",
      }));

    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    // Set column widths
    const columnWidths = [
      { wch: 15 }, // Task Number
      { wch: 30 }, // Description
      { wch: 20 }, // Developer
      { wch: 20 }, // Time Spent
      { wch: 20 }, // Total Time on Task
      { wch: 20 }, // Time Budget
      { wch: 20 }, // Budgetary Performance
      { wch: 25 }, // Date Range
      { wch: 20 }, // Date Start
      { wch: 20 }, // Date End
      { wch: 20 }, // Decimal Time Spent
      { wch: 20 }, // Decimal Total Time on Task
      { wch: 20 }, // Decimal Time Budget
    ];

    // Apply the column widths to the worksheet
    worksheet["!cols"] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "TimeEntries");
    XLSX.writeFile(workbook, fileNameWithExtension);
  }
}
